import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../utils";
import {
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  showToast,
  TableAdv,
  useFormHandler,
} from "../../../../../components";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../../hooks";
import { fetchAddSubmissionData, fetchTalentMatch, updateTalentMatchStatus } from "../../../../../redux/slices/bdmjobs/bdmjobsApi";
import { totalCountStart } from "../../../../../redux/slices/totalCount/totalCountSlice";
import { formatWords2 } from "../../../../../utils/stringUtils";

const TalentMatch = ({ TalentMatchIds, refreshCounts, onShortlistSuccess, jobPostId}) => {
  // console.log("TalentMatchIds",TalentMatchIds)
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedRows, setSelectedRows] = useState([]);
  const [talentMatchRows, setTalentMatchRows] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => {}
      );
  const { value } = useSelector((state) => state?.totalCount);
  const totalCount = value?.talentMatchCount?.data || 0;
  const { user } = useSelector((state) => state.auth);
  const [talentMatchMap, setTalentMatchMap] = useState({});

  const colTalentMatch = [
    // {
    //   key: "sNo",
    //   label: "S.No",
    // },
    {
      key: "name",
      label: "Name",
      // render: (row) => <div className="text-info">{formatWords2(row?.name)}</div>,
      render: (row) => (
        <Link
          to={`/ats/applicants/applicant-details`}
          state={{ applicantId: row?.candidateId, source: "/ats/jobs/job-details?job-details=talent-match", selectedJobUiid:jobPostId  }}
          className="text-info flex items-center gap-.5"
        >
          <span className="mx-2">{formatWords2(row?.name)}</span>
        </Link>
      ),
    },
    {
      key: "email",
      label: "Email ID",
    },
    {
      key: "phone",
      label: "Phone number",
    },
    {
      key: "jobTitle",
      label: "Job Title",
    },
    {
      key: "experience",
      label: "Experience (In years)",
    },
    {
      key: "workAuthorization",
      label: "Work Authorization",
    },
    {
      key: "location",
      label: "Location",
    },
    {
      key: "relevance",
      label: "Relevenace",
      render: (row) => <div className="text-info">{row?.relevance}</div>,
    },
  ];

  const rowTalentMatch = Array.from({ length: 5 }, (_, i) => ({
    id: i + 100,
    sNo: i + 1,
    name: "Jack Raison",
    email: "jackrai@gmail.com",
    phone: "+(1)7984592873",
    jobTitle: "Frontend Developer",
    experience: "3",
    workAuthorization: "USA",
    location: "Dallas",
  }));

  // const mappedRowTalentMatch = mapTableRows(rowTalentMatch, colTalentMatch);

  const intitialFormData = {
    emailSource: "",
    emailAccount: "",
    datePicker: "",
    template: "",
    subject: "",
    emailText: "",
  };

  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    intitialFormData,
    {
      emailSource: { type: "select", required: true },
    }
  );

  const handleSelectionChange = (selected) => {
    setSelectedRows(selected);
  };
  const handleModalOpen = (title) => {
    setIsModalOpen(true);
    setModalTitle(title);
  };

  const handleShortlistClick = async () => {
    if (selectedRows.length === 0) {
      navigate("/ats/jobs/job-details?job-details=shortlisted");
      return;
    }
    try {
      setLoading(true);
      const createdSubmissionIds = [];

      for (const row of selectedRows) {
        const original = talentMatchMap[row];
        const candidateId = original?.candidateId?.uiid;
        const jobPostId = original?.jobPostId?.uiid;
        const payload = [
          {
            type: "PUSH",
            value: {
              statusHistory: {
                addedBy: user?.data?.uiid,
                addedOn: new Date().toISOString(),
                status: 2, // Shortlist status
              },
            },
          },
        ];
        const res = await updateTalentMatchStatus({
          coll: "TalentMatche",
          uiid: row,
          payload,
        });
        if(res?.data) {
          const res = await fetchAddSubmissionData({
            coll: "Submission",
            postActions: ["addToSubmit"],
            payload: {
              candidateId: candidateId,
              jobPostId : jobPostId,
              statusHistory: [{
                status: 1,
                addedBy: user?.data?.uiid,
                addedOn: new Date()
              }],
              addedBy: user?.data?.uiid,
              currentStatus: 1
            },
          });
          console.log("res?.data",res?.data);
          const uiid = res?.data?.data?.uiid;
          console.log("Created Submission ID:", uiid);
          if (uiid) createdSubmissionIds.push(uiid);
        }
      }
      
      showToast("Updated to Shortlisted successfully", "success");
      if (typeof refreshCounts === "function") {
        refreshCounts();
      }
      onShortlistSuccess?.(createdSubmissionIds);
      navigate("/ats/jobs/job-details?job-details=shortlisted");
    } catch (err) {
      console.error(err);
      showToast("Failed to update shortlist status", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchTalentMatches = async () => {
    try {
      setLoading(true);
      const res = await fetchTalentMatch({
        coll: "TalentMatche",
        pg: page,
        lim: limit,
        ref: "JobPosting Candidate",
        ret: "uiid candidateId jobPostId skillMatchPercent",
        fil: {
          uiid: { type: "IN", value: TalentMatchIds }, "statusHistory.status": {
            type: "ARRAY_LAST_TWO_FIELDS_EQ",
            value: 1,
          }
        },
        extret: "uiid firstName",
        incl: [
          "jobInfo.workAuth jobInfo.location uiid",
          "uiid firstName lastName email mobile salaryInfo.payRate jobTitle exp workAuth location",
        ],
        // sort: { addedOn: -1 },
      });

      const data = res?.data?.data || [];
      const formattedRows = data.map((item, index) => ({
        id: item?.uiid,
        sNo: index + 1,
        name: `${item?.candidateId?.firstName || ""} ${
          item?.candidateId?.lastName || ""
        }`.trim(),
        // email: item?.candidateId?.email?.primary || item?.candidateId?.email || "N/A",
        email:
          typeof item?.candidateId?.email === "string"
            ? item?.candidateId?.email
            : item?.candidateId?.email?.primary?.email || "N/A",
        phone: item.candidateId?.mobile?.primary
      ? `${item.candidateId?.mobile?.primary?.code} ${item?.candidateId?.mobile?.primary?.number}`
      : "N/A",
        jobTitle: formatWords2(item?.candidateId?.jobTitle || "N/A"),
        experience: item?.candidateId?.exp ? `${item?.candidateId?.exp?.year || 0}y ${item?.candidateId?.exp?.mon || 0}m`
          : "N/A",
        // workAuthorization: item?.jobPostId?.jobInfo?.workAuth?.length > 0 ? item?.jobPostId?.jobInfo?.workAuth : "N/A",
        workAuthorization: item?.candidateId?.workAuth ? formatWords2(item?.candidateId?.workAuth) : "N/A",
        // location: item?.jobPostId?.jobInfo?.location
        //   ? `${item?.jobPostId?.jobInfo?.location?.city || ""}, ${item?.jobPostId?.jobInfo?.location?.state || ""}`
        //   : "N/A",
        location: (() => {
          const loc = item?.candidateId?.location;
          const formatted = [loc?.city, loc?.state].filter(Boolean).join(", ");
          return formatted || "N/A";
        })(),
        candidateId: item?.candidateId?.uiid || null,
        jobPostingId: item?.jobPostId?.uiid || null,
        relevance: item.skillMatchPercent ? item.skillMatchPercent + "%" : "N/A"
      }));

      const map = {};
      data.forEach((item) => {
        map[item.uiid] = item;
      });

      setTalentMatchMap(map);

      setTalentMatchRows(mapTableRows(formattedRows, colTalentMatch));
    } catch (err) {
      console.error("Error fetching submissions:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "talentmatches",
        coll: "TalentMatche",
        tname: "talentMatchCount",
        app: "ats",
        filters: { uiid: { type: "IN", value: TalentMatchIds } },
      })
    );
    fetchTalentMatches();
  }, [TalentMatchIds, limit, page]);
  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center h-64">
  //       <LogoLoader />
  //     </div>
  //   );
  // }
  return (
    <div className="flex flex-col gap-5 my-5 flex-1 overflow-hidden">
      <div className="flex-1 overflow-hidden flex gap-4 p-0.5">
        <div className="flex-1 overflow-hidden shadow-tableset">
          <TableAdv
            showSlNo
            showCheckbox
            columns={colTalentMatch}
            // rows={mappedRowTalentMatch}
            rows={talentMatchRows}
            tdClassName="!py-3"
            onSelectionChange={handleSelectionChange}
            defaultSelectedRows={selectedRows}
            serverPagination={true}
            totalCount={totalCount}
            page={page}
            limit={limit}
            onPaginationChange={setPage}
            onLimitChange={handleLimitChange}
            toolbarRight={{
              search: true,
              add: [
                {
                  component: (
                    <div className="flex items-center gap-2">
                      {selectedRows.length <= 1 ? (
                        <Button
                          title="Send Mail"
                          size="sm"
                          onClick={() => handleModalOpen("Send Mail")}
                        />
                      ) : (
                        <Button
                          title="Bulk Mail"
                          size="sm"
                          onClick={() => handleModalOpen("Bulk Mail")}
                        />
                      )}

                      <Button
                        title="Shortlist"
                        size="sm"
                        onClick={() =>
                          // navigate(
                          //   "/ats/jobs/job-details?job-details=shortlisted"
                          // )
                          handleShortlistClick()
                        }
                      />
                    </div>
                  ),
                },
              ],
            }}
          />
        </div>
      </div>
      <Modal isOpen={isModalOpen} showCloseButton={false} width="max-w-6xl">
        <div>
          <Button
            color="black"
            icon={"arrow_left_alt"}
            variant="text"
            title={modalTitle}
            className="!px-0 font-[500]"
            size="xl"
            onClick={() => setIsModalOpen(false)}
          />
        </div>
        <div className="grid grid-cols-2 xl:grid-cols-3 gap-5">
          <FormFieldSet
            type="select"
            title="Email Source"
            placeholder="Select"
            options={[
              { label: "Gmail", value: 1 },
              { label: "Outlook", value: 2 },
              { label: "Mailgun", value: 3 },
              { label: "AWS-SES", value: 4 },
            ]}
            value={formData.emailSource}
            onChange={(value) => handleChange("emailSource", value)}
            error={errors.emailSource}
          />
          <FormFieldSet
            type="select"
            title="Email Account"
            placeholder="Select Account"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            value={formData.emailAccount}
            onChange={(value) => handleChange("emailAccount", value)}
            error={errors.emailAccount}
          />
          <FormFieldSet
            type="datepicker"
            title="Date Picker"
            placeholder="Select Date"
            value={formData.datePicker}
            onChange={(value) => handleChange("datePicker", value)}
            error={errors.datePicker}
          />
          <FormFieldSet
            type="select"
            title="Template"
            placeholder="Select"
            options={[
              { label: "Brown", value: 1 },
              { label: "Aden", value: 2 },
            ]}
            value={formData.template}
            onChange={(value) => handleChange("template", value)}
            error={errors.template}
          />
          <FormFieldSet
            title="Subject"
            placeholder="Select"
            value={formData.subject}
            onChange={(value) => handleChange("subject", value)}
            error={errors.subject}
          />
        </div>
        <div className="flex flex-col my-4 gap-4">
          <FormFieldSet
            value={["simon@tektreeinc.com", "john.doe@tektreeinc.com"]}
            maxCount={50}
            type="toMailIds"
            title="Include Test Emails Here: 2"
          />
          <FormFieldSet
            type="textArea"
            title="Text Here"
            rows={5}
            placeholder="Enter Text Here"
            value={formData.emailText}
            onChange={(value) => handleChange("emailText", value)}
            error={errors.emailText}
          />
        </div>
        <div className="flex justify-end gap-5 my-10">
          <Button
            variant="outlined"
            title={"Cancel"}
            onClick={() => setIsModalOpen(false)}
          />
          <Button title={"Send Email"} />
        </div>
      </Modal>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default TalentMatch;
